/**
 * Example:
 *  var myStyle = new CpqStyle();
 *  myStyle['background-color'] = 'blue'; myStyle['font-size']='14px',...
 */
export class CpqStyle {
}